export default __webpack_public_path__ + "static/media/beyond-the-blue-planet-enp-2020.10093712.jpg";